import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
  drawer : {
    width: 260,
    zIndex: 1200,
  },
  drawerPaper: {
    boxShadow: '3px 5px 13px -3px rgba(153,151,153,1)',
    width: 260,
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    padding:'0px',
    borderBottom: '1px solid lightGrey',
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    paddingLeft: theme.spacing(4),
  },
  subMenu : {
    paddingLeft : '50px !important',
  },
  footer : {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: theme.spacing(2),
  }
}));
export default useStyles;
